import { render, staticRenderFns } from "./swiperBanner.vue?vue&type=template&id=1d2fe69a&scoped=true&"
import script from "./swiperBanner.vue?vue&type=script&lang=ts&"
export * from "./swiperBanner.vue?vue&type=script&lang=ts&"
import style0 from "./swiperBanner.vue?vue&type=style&index=0&id=1d2fe69a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fe69a",
  null
  
)

export default component.exports